<template>
	<page>
		<module>
			<view-list ref="view" work-type="61" dynamic-field :field-sort="false" :view-config="auth('b_performance_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="工单状态">
							<c-select name="work_states" :options="orderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="部门">
							<c-select name="department_ids" async multiple @search="searchDepartment"></c-select>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="报工审批状态">
							<c-select name="output_states" :options="auditStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="时间维度字段">
							<c-select name="date_field" :options="dateFieldOptions" :clear="false"></c-select>
						</m-search-item>
						<m-search-item label="时间范围">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="统计维度">
							<c-select name="dimension_id" :options="dimensionOption.active" :disable-options="dimensionOption.disabled" :clear="false">
								<template #option="{data, selected, disabled}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="disabled"
									></select-option>
								</template>
							</c-select>
						</m-search-item>
					</m-search>
				</template>
				
				<template #operate>
					<c-button v-if="auth('b_performance_export')" v-lock="lock('b_performance_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>
				
				<!--部门-->
				<template #department_names="{data}">
					<span v-if="!data.department_names">-</span>
					<c-tags v-else :value="data.department_names"></c-tags>
				</template>
				<!--角色-->
				<template #role_names="{data}">
					<span v-if="!data.role_names">-</span>
					<c-tags v-else :value="data.role_names"></c-tags>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					dimension_id: 100,
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-6).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd')
				}
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic', 'dateFieldOptions', 'auditStateDic']),
			...mapGetters(['freeEdition']),

			dimensionOption() {
				let options = [{
					name: '生产人员',
					value: 100
				}, {
					name: '生产人员+工序',
					value: 101
				}, {
					name: '生产人员+产品+工序',
					value: 102
				}];

				return {
					active: options,
					disabled: this.freeEdition ? options.filter(item => item.name.includes('+')).map(item => item.value) : []
				}
			}
		},

		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索部门*****************/
			searchDepartment(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DEPARTMENT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>